import {
  PLAN_ACTIVITY_URL,
  PLAN_ACTIVITY_RESULT_URL,
} from "containers/TimeSlotPlanner/constants";
import Poller from "utils/Polling/Poller";

export default class ResultPoller extends Poller {
  constructor(successAction, failedAction, startAction = () => {}) {
    super(
      PLAN_ACTIVITY_URL,
      PLAN_ACTIVITY_RESULT_URL,
      successAction,
      failedAction,
      startAction,
    );
  }

  handleData = (err, data) => {
    if (err) {
      this.failedAction(err);
    } else {
      this.successAction(data.plannedTimeSlot);
    }
  };

  async getData(activity, id = -1) {
    const body = {
      data: {
        activity: {
          duration: activity.duration,
          time_slots: activity.time_slots.slice(),
          tag_names: ["blok"],
        },
      },
      withScanner:activity.withScanner
    };

    if (id !== -1) {
      body.plannedTimeSlot = {
        id,
      };
    }

    return super.getData(body);
  }
}
